"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designSystem = require("@slyk/design-system");

var _media = require("react-components/media");

var _styles = require("./styles");

var _styles2 = require("react-components/styles");

var _breakpoint = require("@slyk/breakpoint");

var _react = _interopRequireWildcard(require("react"));

var _qs = _interopRequireDefault(require("qs"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var facebookIcon16 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\"><path fill=\"currentColor\" d=\"M15.5 8.546a7.5 7.5 0 10-8.672 7.409v-5.241H4.924V8.546h1.904V6.894c0-1.88 1.12-2.918 2.833-2.918.562.007 1.123.056 1.679.146v1.846h-.946c-.932 0-1.222.578-1.222 1.171v1.407h2.08l-.333 2.168H9.172v5.24A7.502 7.502 0 0015.5 8.547z\"/></svg>";
var facebookIcon24 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M23.25 12.567A11.25 11.25 0 1010.242 23.68v-7.86H7.386v-3.252h2.856v-2.479c0-2.82 1.68-4.377 4.25-4.377a17.42 17.42 0 012.518.22V8.7h-1.42c-1.397 0-1.833.867-1.833 1.757v2.11h3.12l-.499 3.252h-2.621v7.861a11.253 11.253 0 009.492-11.113z\"/></svg>";

/**
 * Facebook authentication url.
 */
var facebookAuthenticationUrl = 'https://www.facebook.com/v9.0/dialog/oauth';
/**
 * `Props` type.
 */

/**
 * `FacebookSocialButton` styled component.
 */
var FacebookSocialButton = (0, _styledComponents["default"])(_designSystem.Button).withConfig({
  displayName: "facebook-button__FacebookSocialButton",
  componentId: "sc-443tz8-0"
})(["margin-bottom:", ";transition-property:background-color,color,opacity;&,&:focus,&:hover{background-color:", ";color:", ";}&:disabled{opacity:0.5;}"], (0, _styles2.units)(1), (0, _styles2.color)('facebook'), (0, _styles2.color)('white'));
/**
 * `FacebookButton` component.
 */

function FacebookButton(props) {
  var children = props.children,
      credentials = props.credentials,
      disabled = props.disabled,
      responsive = props.responsive;
  var isDesktop = (0, _breakpoint.useBreakpoint)('ms', 'min');
  var isResponsive = !!responsive;
  var iconButton = isDesktop ? facebookIcon24 : facebookIcon16;
  var iconSize = isDesktop ? (0, _styles2.units)(3) : (0, _styles2.units)(2);
  var facebookUrl = (0, _react.useMemo)(function () {
    var _credentials$state;

    var params = {
      client_id: credentials.clientId,
      nonce: credentials.clientId,
      redirect_uri: credentials.redirectUrl,
      response_type: 'token',
      state: _qs["default"].stringify(_objectSpread({
        identityProvider: 'facebook',
        scope: 'authentication',
        slug: credentials.slug,
        type: credentials.type
      }, (_credentials$state = credentials.state) !== null && _credentials$state !== void 0 ? _credentials$state : {}))
    };
    var url = new URL(facebookAuthenticationUrl);
    url.search = _qs["default"].stringify(params);
    return url.href;
  }, [credentials]);
  return /*#__PURE__*/_react["default"].createElement(FacebookSocialButton, {
    disabled: disabled,
    fullWidth: true,
    href: facebookUrl,
    responsive: responsive,
    size: 'large'
  }, /*#__PURE__*/_react["default"].createElement(_styles.SocialButtonContent, null, /*#__PURE__*/_react["default"].createElement(_media.Icon, {
    "aria-hidden": true,
    color: (0, _styles2.color)('white'),
    icon: isResponsive ? iconButton : facebookIcon24,
    size: isResponsive ? iconSize : (0, _styles2.units)(3)
  }), children));
}
/**
 * Export `FacebookButton` component.
 */


var _default = FacebookButton;
exports["default"] = _default;